import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "preferential_body"
};
const _hoisted_2 = {
  class: "navbat"
};
const _hoisted_3 = {
  class: "wdyhj_tab"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  key: 0,
  class: "yhj_list"
};
const _hoisted_6 = {
  key: 0,
  src: "https://www.mimodental.com/assets/imgData/img/new/ysx.png",
  alt: "",
  style: {
    "width": "35%",
    "height": "100%",
    "position": "absolute",
    "left": "0"
  }
};
const _hoisted_7 = {
  class: "yhj_l"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  class: "yhj_r"
};
const _hoisted_11 = {
  class: "yhj_an"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  key: 1,
  style: {
    "margin-top": "20%"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/fh.png",
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.fh && $setup.fh(...args))
  }), _cache[1] || (_cache[1] = _createElementVNode("span", null, "我的优惠券", -1))]), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.preferential_tab, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      style: _normalizeStyle('color:' + ($setup.preferential_tab_key == item.key ? '#fff;' : '#E3E3E3;') + 'background:' + ($setup.preferential_tab_key == item.key ? '#41B9B1;' : '#D0D0D0;')),
      onClick: $event => $setup.preferential_tab_click(item.key)
    }, _toDisplayString(item.name), 13, _hoisted_4);
  }), 128))]), $setup.cardRecordsList.length != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cardRecordsList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      style: _normalizeStyle($setup.designsObj[item.cardId]?.background ? 'background:url(' + $setup.designsObj[item.cardId].background + ');background-size:100% 100%;' : '')
    }, [$setup.preferential_tab_key == 5 ? (_openBlock(), _createElementBlock("img", _hoisted_6)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
      style: _normalizeStyle('color:' + ($setup.designsObj[item.cardId]?.titleColor ? $setup.designsObj[item.cardId]?.titleColor : $setup.preferential_tab_key != '1' ? '#525252;' : '#41B8B2;')),
      class: "yhj_text"
    }, [item.cardType != 'discount' ? (_openBlock(), _createElementBlock("span", _hoisted_8, "￥")) : _createCommentVNode("", true), _createElementVNode("h2", null, _toDisplayString(item.cardType != 'discount' ? item.reduceCost : item.discount), 1), item.cardType == 'discount' ? (_openBlock(), _createElementBlock("span", _hoisted_9, "折")) : _createCommentVNode("", true)], 4), _createElementVNode("div", {
      style: _normalizeStyle('background:' + ($setup.designsObj[item.cardId]?.titleColor ? $setup.designsObj[item.cardId]?.titleColor : $setup.preferential_tab_key != '1' ? '#525252;' : '#41B8B2;')),
      class: "yhj_lx"
    }, [_createElementVNode("h2", null, _toDisplayString(item.cardType == 'case' ? '满减券' : item.cardType == 'discount' ? '折扣券' : item.cardType == 'cash' ? '抵价券' : '兑换劵'), 1)], 4)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
      class: "yhj_xx",
      style: _normalizeStyle('color:' + ($setup.designsObj[item.cardId]?.dateColor || '#000'))
    }, [_createElementVNode("h2", null, _toDisplayString(item.title), 1), _createElementVNode("span", null, "有效期：" + _toDisplayString(item.endDateStr), 1)], 4), _createElementVNode("div", _hoisted_11, [_createElementVNode("span", {
      style: _normalizeStyle('color:' + ($setup.designsObj[item.cardId]?.bottomColor || '#41B8B2')),
      onClick: $event => $setup.preferential_tab_key == 1 ? $setup.pay_yhj(item.id) : ''
    }, "使用规则 >", 12, _hoisted_12), _createElementVNode("div", {
      class: "btn_click",
      onClick: $event => $setup.preferential_tab_key == 1 ? $setup.pay_yhj(item.id) : '',
      style: _normalizeStyle('background:' + ($setup.designsObj[item.cardId]?.btnColor || '#41B8B2'))
    }, _toDisplayString($setup.preferential_tab_key == 2 ? '已使用' : '使用'), 13, _hoisted_13)])])], 4);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[2] || (_cache[2] = [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/img/new/que.png",
    style: {
      "width": "40rem"
    },
    alt: ""
  }, null, -1)])))]);
}